import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitFile } from '@/services/git/api';
import type { GitFileContent } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitFile(
  repoFullName: string | null | undefined,
  path: string | null | undefined,
  ref?: string,
): UseQueryResult<GitFileContent | null, Error> {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitFile', orgId, repoFullName, path, ref],
    queryFn: () => fetchGitFile(orgId!, repoFullName!, path!, ref),
    enabled: !!orgId && !!repoFullName && !!path,
    staleTime: 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
    meta: { silent: true },
  });
}
